import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cbd-gbf-logo.jpeg")